const subStatusData = [
  {
    id: 1,
    type: "pending",
    btn: "التالي",
    heading: "شكرًا لك ",
    text1:"تم تقديم طلبك، ستتلقى إشعار الرسالة النصية قريبًا.",
    text2: "",
    icon: require("../../Assets/wap/daretoknowAssets/thank_you_icon.png"),
  },
  {
    id: 2,
    type: "great",
    btn: "العب الآن",
    heading: "رائع",
    text1: "لقد اشتركت في 3 فرص يوميًا.",
    text2: "",
    icon: require("../../Assets/wap/daretoknowAssets/correct_tick.png"),
  },
  {
    id: 3,
    type: "activated",
    btn: "التالي",
    heading: "!تهانينا",
    text1: "أنت مشترك بالفعل في خدمة Swipe&Win.",
    text2: "",
    icon: require("../../Assets/wap/daretoknowAssets/congratulations_activated_icon.png"),
  },
  {
    id: 4,
    type: "subs_fail",
    btn: "حسنًا",
    heading: "!عذرًا",
    // text1:"",
    text1: "لا يوجد لديك رصيد كافي",
    icon: require("../../Assets/wap/daretoknowAssets/sorry_low_balance_icon.png"),
  },
  {
    id: 5,
    type: "technical_error",
    btn: "حاول مرة أخرى",
    heading: "!عذرًا",
    text1: "هناك خطأ فني، يرجى المحاولة بعد فترة من الزمن.",
    text2: "",
    icon: require("../../Assets/wap/daretoknowAssets/sorry_technical_error_icon.png"),
  },
  {
    id: 6,
    type: "plan_upgrade",
    btn: "حسنًا",
    heading: "!تهانينا",
    text1: ".تم تغيير الباقة الخاصة بك",
    text2: "",
    icon: require("../../Assets/wap/zainIraqS4W/thums_up.png"),
  },
  {
    id: 7,
    type: "subscribe",
    btn: "حسنًا",
    heading: "!تهانينا",
    text1 : "لقد تم اشتراكك الان في خدمة تحدي المعرفة",
    text2: "",
    icon: require("../../Assets/wap/daretoknowAssets/congratulations_tick_icon.png"),
  },
];

export { subStatusData };
